
export default {
  methods: {
    isVigenciaFechada (dataFimVigencia) {
      if (!dataFimVigencia) {
        return false
      }
      const dataFim = new Date(dataFimVigencia)
      const dataAtual = new Date()
      return dataFim < dataAtual
    }
  }
}
